import { Fragment, useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { TreeSelect } from "antd";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import SortableList, { SortableItem } from "react-easy-sort";
import arrayMove from "array-move";
import { getCategories, getRecommendCategories } from "actions/categoryAction";
import { getCategoriesProduct } from "actions/categoryProductAction";
import SelectBox from "components/elements/selectBox";
import Loading from "components/Loading";
import { use } from "react";

function ModalCreate({
    onSubmit,
    isOpen,
    onClose,
    getCategories,
    getRecommendCategories,
    product,
    getCategoriesProduct,
}) {
    const [category, setCategory] = useState();
    const [categoryProduct, setCategoryProduct] = useState();
    const [formData, setFormData] = useState();
    const [categoryVersion, setCategoryVersion] = useState("v2");
    const [categories, setCategories] = useState([]);
    const [listCategoriesProduct, setListCategoriesProduct] = useState([]);
    const [isLoadingRecommend, setIsLoadingRecommend] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        setFormData({
            images: product?.images || [],
        });
    }, [product]);

    useEffect(() => {
        getCategories(() => {}, categoryVersion).then((data) =>
            setCategories((data || []).map((c) => ({ value: c.id, label: c.local_name, children: c.children })))
        );
    }, [categoryVersion, getCategories]);

    useEffect(() => {
        getCategoriesProduct(() => {}, categoryVersion).then((data) =>
            setListCategoriesProduct((data?.categoryProducts || []).map((c) => ({ value: c._id, label: c.title })))
        );
    }, [getCategoriesProduct]);

    const handleSubmit = () => {
        onSubmit?.({ categoryVersion, category, categoryProduct, ...formData });
    };

    const onClickGetRecommendCategories = () => {
        setIsLoadingRecommend(true);
        getRecommendCategories(() => {}, categoryVersion || "v2", product?.product_name).then((data) => {
            // setCategories((data || []).map((c) => ({ value: c.id, label: c.local_name, children: c.children })));
            if (data?.[data?.length - 1]?.id) {
                setCategory(data?.[data?.length - 1]?.id);
            }
            setIsLoadingRecommend(false);
        });
    };

    const onSortEnd = (oldIndex, newIndex) => {
        setFormData((prev) => ({
            ...prev,
            images: arrayMove(prev?.images || [], oldIndex, newIndex),
        }));
    };

    return (
        <Fragment>
            <Loading isLoading={isLoadingRecommend} />
            <Modal
                centered={true}
                size="lg"
                toggle={() => {
                    onClose();
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <h2 className="mb-0 text-info">Choose Category</h2>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                onClose();
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="d-flex justify-content-between mb-5 w-100 flex-column gap-4">
                        <div className="form-group w-100">
                            <label className="required">Category</label>
                            <div className="row">
                                <div className="col-md-4">
                                    <TreeSelect
                                        showSearch
                                        style={{ width: "100%" }}
                                        treeNodeFilterProp="label"
                                        dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                                        className="h-100"
                                        placeholder="Please select"
                                        onChange={(cate) => {
                                            setCategory(cate);
                                        }}
                                        treeData={categories}
                                        value={category}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <SelectBox
                                        options={listCategoriesProduct}
                                        name="categoryProduct"
                                        value={categoryProduct}
                                        onChange={(data) => setCategoryProduct(data?.value)}
                                        className="basic-multi-select al-custom-select-search-variants mr-1 mb-0 al-filter-table me-2 css-b62m3t-container mt-2"
                                        placeholder="Select a niche system ... "
                                    />
                                </div>
                                <div className="col-md-4">
                                    <SelectBox
                                        options={[
                                            { value: "v1", label: "v1" },
                                            { value: "v2", label: "v2" },
                                        ]}
                                        className="basic-multi-select al-custom-select-search-variants mr-1 mb-0 al-filter-table me-2 css-b62m3t-container mt-2"
                                        name="category_version"
                                        value={categoryVersion || "v2"}
                                        onChange={(data) => {
                                            setCategoryVersion(data?.value);
                                            setCategoryProduct("");
                                        }}
                                    />
                                </div>
                            </div>
                            <label className="required mt-4">Images</label>
                            <div className="row">
                                <SortableList
                                    onSortEnd={onSortEnd}
                                    className="al-thumbsContainer"
                                    draggedItemClassName="dragged"
                                >
                                    {formData?.images.map((link, key) => (
                                        <SortableItem key={key}>
                                            <div className="al-thumb">
                                                <div className="al-thumbInner position-relative">
                                                    <button
                                                        onClick={() =>
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                images: (prev?.images || []).filter(
                                                                    (_s, k) => k !== key
                                                                ),
                                                            }))
                                                        }
                                                        type="button"
                                                        className="btn-delete-image"
                                                    >
                                                        <i className="fa fa-trash" />
                                                    </button>
                                                    <img
                                                        src={link}
                                                        alt=""
                                                        className="al-product-img al-cursor-move w-100 h-100"
                                                        draggable="false"
                                                        style={{ objectFit: "cover" }}
                                                    />
                                                </div>
                                            </div>
                                        </SortableItem>
                                    ))}
                                </SortableList>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-12">
                                    <button
                                        className="btn btn-info btn-sm"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content={t("Recommend Category")}
                                        onClick={() => onClickGetRecommendCategories()}
                                    >
                                        <i className="fa fa-lightbulb" style={{ fontSize: "20px" }}></i> Recommend
                                        Category
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        onClick={handleSubmit}
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                    >
                        {t("Save")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({
    productTemplate: state.productTemplate?.list?.map((v, i) => {
        return { value: v._id, label: v.title };
    }),
});
const mapDispatchToProps = { getCategories, getRecommendCategories, getCategoriesProduct };

export default connect(mapStateToProps, mapDispatchToProps)(ModalCreate);
